import * as React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import extractLinkData from '@utility/extractLinkData'
import { SitemapItem, Sitemap, UserType } from '@type/component-data-types.d'

type Props = {
  isUserType: UserType
}

const isUserTypeItemClassName = (itemType: string) =>
  itemType === 'client' ? 'isClientItem' : 'isPartnerItem'

const GlobalNavigation = (props: Props): React.JSX.Element => {
  const isUserType = props.isUserType || 'partner'

  // GQL query
  const data = useStaticQuery(graphql`
    query {
      allDataJson {
        nodes {
          partnerLinkData {
            path
            name
            key
            useLinkApi
          }
          clientLinkData {
            key
            name
            path
            useLinkApi
          }
        }
      }
    }
  `)

  const linkData: any = data.allDataJson.nodes[0]

  //パートナー向けのリンク先を取得する
  const preSitemapPartner: Array<SitemapItem> = extractLinkData(
    linkData.partnerLinkData,
    [
      'aboutAffiliate',
      'aboutAfb',
      'selfbAlias',
      'snsAffiliateAlias',
      'featureAlias',
    ],
  )

  // memo: クライアントTOPへのリンクが必要なので取得する
  const partnerMapFragment: Array<SitemapItem> = extractLinkData(
    linkData.clientLinkData,
    ['clientTopAlias'],
  )
  // memo: nameの内容が異なるので変更する
  partnerMapFragment[0].itemType = 'client'
  // パートナー向けのリンク先配列とクライアントTOPへのリンクを結合
  const sitemapPartner: Array<SitemapItem> =
    preSitemapPartner.concat(partnerMapFragment)

  // memo: クライアント向けのリンク先を取得する
  const preSitemapClient: Array<SitemapItem> = extractLinkData(
    linkData.clientLinkData,
    [
      'clientAboutAfb',
      'clientIntroduction',
      'clientFaq',
      'clientInterview',
      'clientContact',
    ],
  )
  // styleを調整するためのitemTypeを追加する
  preSitemapClient.forEach(item => {
    item.itemType = 'client'
  })
  // memo: パートナーTOPへのリンクが必要なので取得する
  const clientMapFragment: Array<SitemapItem> = extractLinkData(
    linkData.partnerLinkData,
    ['topAlias'],
  )

  const sitemapClient: Array<SitemapItem> =
    preSitemapClient.concat(clientMapFragment)

  // リンク先のデータをまとめる
  const contents: Sitemap = {
    partner: sitemapPartner,
    client: sitemapClient,
  }

  // モバイルメニューの内容を生成する処理
  let navItems: Array<any>
  if (isUserType === 'partner') {
    navItems = contents.partner
  } else if (isUserType === 'client' || isUserType === 'client-no-form') {
    navItems = contents.client
  } else {
    navItems = contents.partner
  }

  return (
    <>
      <div className="globalNavigation">
        <nav>
          <ul
            className={
              'globalNavigation__itemList p-0 ' +
              `${isUserTypeItemClassName(isUserType)}`
            }
          >
            {navItems.map((elm: any, index: number) => (
              <li
                key={`globalNav${index}`}
                className={
                  'text-center u-layout-center globalNavigation__item ' +
                  `${isUserTypeItemClassName(elm.itemType)}`
                }
              >
                {elm.useLinkApi ? (
                  <Link
                    to={elm.path}
                    activeClassName="isActive"
                    {...(elm.path === '/advertiser/'
                      ? { 'data-cta-location': 'header' }
                      : {})}
                  >
                    {elm.name}
                  </Link>
                ) : (
                  <a href={elm.path}>{elm.name}</a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  )
}

export default GlobalNavigation
